export default "__VITE_ASSET__CpHS1XgK__"